import axios from 'axios'
import {
  SpecificAccountCodeOptionResponse,
  ContractReportResponse
} from '@/types/api'

const baseUrl = `${process.env.VUE_APP_API_URL_BASE}/agreement`

export default {
  // 約款取得API
  contract (companyId: string): Promise<ContractReportResponse> {
    return new Promise((resolve, reject) => {
      axios.get(`${baseUrl}/contract`, { params: { companyId } })
        .then(({ data }: { data: ContractReportResponse }) => {
          resolve(data)
        }).catch((errors) => {
          reject(errors)
        })
    })
  },

  // 前書面取得API
  precontract (companyId: string): Promise<ContractReportResponse> {
    return new Promise((resolve, reject) => {
      axios.get(`${baseUrl}/precontract`, { params: { companyId } })
        .then(({ data }: { data: ContractReportResponse }) => {
          resolve(data)
        }).catch((errors) => {
          reject(errors)
        })
    })
  },

  // 特定口座の選択肢取得API
  specificAccountCodes (): Promise<SpecificAccountCodeOptionResponse> {
    return new Promise((resolve, reject) => {
      axios.get(`${baseUrl}/specificAccountCodes`)
        .then(({ data }: { data: SpecificAccountCodeOptionResponse }) => {
          resolve(data)
        }).catch((errors) => {
          reject(errors)
        })
    })
  }

}
